export default {
  path: '',
  component: () => import(`@/page/distributor/component/basic-layout/1.0.4/index.vue`),
  children: [
    {
      path: '/distributor/train/front/reserve',
      name: 'distributor-train-front-reserve',
      component: () => import('./index.vue'),
    },
  ]
};
